var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nullOrder"},[_c('img',{attrs:{"src":require("../assets/nullCar.png"),"alt":""}}),_c('p',[_vm._v("您的订单是空空如也，快去加购商品吧~")]),_c('div',{on:{"click":_vm.toAIndex}},[_vm._v("去加购商品")])])}
var staticRenderFns = []

export { render, staticRenderFns }